import React from "react";
import styles from "./Card.module.scss";
import { useColorModeValue } from "../../hooks/useColorModeValue";
import { useMediaQuery } from "react-responsive";


const DataCard = (props) => {
  const { text, index, label } = props;

  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });

  return (
    <div 
    data-aos-duration={"600"}
    data-aos-delay={isMobile ? null : index * 200}
    data-aos={isMobile ? "fade-right" : "fade-up"}
    className={styles["main-container"]}>
    <div className={styles["sub-container"]}>
      <div className={styles[useColorModeValue("contentLight","contentDark")]}>
          <p>{text}</p>
        </div>
        <div className={styles[useColorModeValue("textLight","textDark")]}>
        </div>
      </div>
      <h2 className={styles[useColorModeValue("labelLight","labelDark")]}>{label}</h2>
 </div>
  );
};

export default DataCard;